import { connect } from 'react-redux';
import { compose, lifecycle, withProps, withHandlers } from 'recompose';
import { pick } from 'ramda';

import { withRouter } from 'react-router';

import { t } from '../../../../../../modules/infra/i18n';
import withNewDesignStyles from '../../../../../common/hoc/withNewDesignStyles';
import withNotifications from '../../../../../common/withNotifications';
import withLoading from '../../../../../common/withLoading';
import confirmModal from '../../../../../common/confirmModal';
import EditCustomReport from './EditCustomReport';
import { getUserUrlPrefix } from '../../../../../auth/selectors';
import {
  getMetricsDefinitions,
  isMetricsDefinitionsFetched,
  getReportDefinitionById,
} from '../../selectors';
import {
  fetchMetricsDefinitions,
  fetchReportDefinition,
  updateCustomReport,
  deleteCustomReport,
} from '../../actions';
import {
  getApiReportFromFormValues,
  getCustomReportLink,
} from '../../utils';
import form from './formConfig';

const EditCustomReportContainer = compose(
  withNewDesignStyles,
  withRouter,
  withNotifications,
  connect(
    (state, ownProps) => ({
      item: getReportDefinitionById(state, ownProps.params.id),
      metricsDefinitions: getMetricsDefinitions(state),
      fetchedFields: isMetricsDefinitionsFetched(state),
      urlPrefix: getUserUrlPrefix(state),
    }),
    {
      fetchMetricsDefinitions,
      fetchReportDefinition,
      updateCustomReport,
      deleteCustomReport,
    }
  ),
  withProps(props => ({
    title: t('reports:custom_report_form.edit_title'),
    canDelete: true,
    showLoading: !props.fetchedFields || !props.item,
    backLink: props.item ? getCustomReportLink(props.item) : '/reports',
    initialValues: props.item ? pick(['name', 'type'], props.item) : {},
  })),
  withHandlers({
    onSubmit: props => async (values) => {
      const confirmed = await confirmModal({
        type: 'defaultSafe',
        title: t('reports:custom_report_form.save_modal_title'),
        message: t('reports:custom_report_form.save_modal_message'),
        confirmButtonText: t('reports:custom_report_form.save_template_button'),
        negativeButtonText: t('common:modal.cancel_button'),
      });

      if (!confirmed) {
        return false;
      }

      return props.updateCustomReport(
        props.item.id,
        getApiReportFromFormValues(values)
      );
    },
    handleDelete: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: t('reports:custom_report_form.delete_modal_title'),
        message: t('reports:custom_report_form.delete_modal_message'),
        confirmButtonText: t('reports:custom_report_form.delete_report_button'),
        negativeButtonText: t('common:modal.cancel_button'),
      });

      if (!confirmed) {
        return false;
      }

      return props.deleteCustomReport(props.item.id)
        .then(() => {
          props.router.replace('/reports');
          props.addNotification({
            level: 'success',
            message: t('reports:custom_report_form.delete_success_message'),
            title: t('common:notifications.success_title_alt'),
          });
        })
        .catch(() => {
          props.router.replace('/reports');
        });
    },
  }),
  form,
  withHandlers({
    setReportMetrics: props => (reportMetrics) => {
      props.change('reportMetrics', reportMetrics);
    },
  }),
  lifecycle({
    componentWillMount() {
      this.props.fetchMetricsDefinitions();

      if (!this.props.item) {
        this.props.fetchReportDefinition(this.props.params.id);
      }
    },
  }),
  withLoading,
)(EditCustomReport);

export default EditCustomReportContainer;
